import { render, staticRenderFns } from "./IconMoreBtn.vue?vue&type=template&id=34ebac5f&"
import script from "./IconMoreBtn.vue?vue&type=script&lang=ts&"
export * from "./IconMoreBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports